
  import AeqIDValidatorBase from "./AeqIDValidatorBase.vue"

  // Step constants
  const STEP_SELECT_TYPE = 1

  export default {
    name: `AeqIDValidator`,
    extends: AeqIDValidatorBase,
    data() {
      return {
        type: `id`,
        document: {
          type: null,
          withMrz: null,
          withMrzCropped: null,
          withoutMrz: null,
          withoutMrzCropped: null
        },
        step: STEP_SELECT_TYPE,
        wantedDocType: `id_document`
      }
    },
    methods: {
      getDocName(side) {
        if (this.document.type === `passport`) {
          return `Passport.png`
        }
        if (side === "front") {
          return `ID-Front.png`
        }
        return `ID-Back.png`
      },
      shouldShowPrevButton() {
        if (this.step === STEP_SELECT_TYPE) {
          return false
        }
        return true
      },
      getDocType() {
        return this.document.type || this.type
      },
      resetSteps() {
        this.step = STEP_SELECT_TYPE
      }
    }
  }
